import { useQuery } from '@tanstack/react-query'

import {
  DiagnosesCountByRegionIdResponse,
  getDiagnosesCountByRegionId,
} from '@/services/get-diagnoses-count-by-region-id'

interface UseGetDiagnosesCountByRegionId {
  regionId?: number
}

export const useGetDiagnosesCountByRegionId = ({
  regionId,
}: UseGetDiagnosesCountByRegionId) => {
  return useQuery<DiagnosesCountByRegionIdResponse>({
    queryKey: ['diagnoses-count-by-region-id', regionId],
    queryFn: () => getDiagnosesCountByRegionId(regionId!),
    enabled: !!regionId,
  })
}
